import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'context/AuthContext';

interface EffectivePriceListChipProps {
  contrast?: boolean;
}

const EffectivePriceListChip: React.FC<EffectivePriceListChipProps> = ({ contrast }) => {
  const { t } = useTranslation('common');
  const { isAuthenticated, customer } = useAuthContext();
  if (!isAuthenticated || !customer?.priceListId) return null;

  const label = customer.priceListName?.trim() || customer.priceListId;

  return (
    <Chip
      size="small"
      variant={contrast ? 'filled' : 'outlined'}
      color={contrast ? 'default' : 'primary'}
      label={t('nav.priceList', { name: label })}
      title={customer.priceListId}
      sx={{
        display: { xs: 'none', md: 'inline-flex' },
        maxWidth: 220,
        fontWeight: 600,
        ...(contrast
          ? {
              bgcolor: 'rgba(255,255,255,0.16)',
              color: 'inherit',
              '& .MuiChip-label': { color: 'inherit' },
            }
          : {}),
      }}
    />
  );
};

export default EffectivePriceListChip;
